import axios from "axios";

const ROOT_URL = process.env.REACT_APP_API_ROOT_URL;

// User Account Functions
export const DO_LOGIN_SUCCESS = "DO_LOGIN_SUCCESS";
export const DO_LOGIN_OTP_REQUIRED = "DO_LOGIN_OTP_REQUIRED";
export const RESEND_LOGIN_OTP_SUCCESS = "RESEND_LOGIN_OTP_SUCCESS";
export const USER_LOGOUT = "USER_LOGOUT";
// Room/Request Functions
export const GET_OPEN_ROOMS_SUCCESS = "GET_OPEN_ROOMS_SUCCESS";
export const SELECT_ROOM_TO_CHAT = "SELECT_ROOM_TO_CHAT";
export const LEAVE_ROOM_TO_CHAT = "LEAVE_ROOM_TO_CHAT";
export const ADD_OPEN_ROOM_ON_THE_FLY = "ADD_OPEN_ROOM_ON_THE_FLY";
export const DELETE_OPEN_ROOM_ON_THE_FLY = "DELETE_OPEN_ROOM_ON_THE_FLY";
export const UPDATE_OPEN_ROOM_ON_THE_FLY = "UPDATE_OPEN_ROOM_ON_THE_FLY";
// Records Room Functions
export const GET_RECORDS_ROOMS_SUCCESS = "GET_RECORDS_ROOMS_SUCCESS";
// Admin User Functions
export const CREATE_NEW_ADMIN_USER_SUCCESS = "ADD_NEW_ADMIN_USER_SUCCESS";
export const GET_ADMIN_USER_LIST_SUCCESS = "GET_ADMIN_USER_LIST_SUCCESS";
export const UPDATE_ADMIN_USER_PASSWORD_SUCCESS =
  "UPDATE_ADMIN_USER_PASSWORD_SUCCESS";
export const UPDATE_ADMIN_PREFERENCES_SUCCESS =
  "UPDATE_ADMIN_PREFERENCES_SUCCESS";
export const PASSWORD_CHANGE_OTP_REQUIRED = "PASSWORD_CHANGE_OTP_REQUIRED";
// Statistics Functions
export const GET_STATISTICS_DATA_SUCCESS = "GET_STATISTICS_DATA_SUCCESS";
// Notification Functions
export const ADD_NEW_NOTIFICATION = "ADD_NEW_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
// Error Functions
export const DO_API_ERROR_RESPONSE = "DO_API_ERROR_RESPONSE";
// Admin Invitation / Setup Password Functions
export const VERIFY_ADMIN_INVITATION_SUCCESS =
  "VERIFY_ADMIN_INVITATION_SUCCESS";
export const SETUP_ADMIN_PASSWORD_SUCCESS = "SETUP_ADMIN_PASSWORD_SUCCESS";
export const RESEND_ADMIN_INVITATION_SUCCESS =
  "RESEND_ADMIN_INVITATION_SUCCESS";

// Password step only. A success here means an OTP was emailed - it does NOT
// establish a session, so this must not dispatch DO_LOGIN_SUCCESS: that would
// set user.data to undefined and the login screen would silently do nothing.
// The pendingToken reaches the caller through the callback and never enters the
// store, which redux-persist would otherwise write to localStorage.
export function doLogin({ email, password }, callback) {
  const url = `${ROOT_URL}/admin/doLogin`;
  return axios
    .post(url, {
      email,
      password,
    })
    .then((response) => {
      callback(response.data, null);
      return {
        type: DO_LOGIN_OTP_REQUIRED,
        payload: null,
      };
    })
    .catch((error) => {
      console.log("doLogin", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error,
      };
    });
}

// Completes the login. This is now the only place a session is established.
export function verifyLoginOtp({ pendingToken, otpCode }, callback) {
  const url = `${ROOT_URL}/admin/verify-login-otp`;
  return axios
    .post(url, { pendingToken, otpCode })
    .then((response) => {
      callback(response.data, null);
      return {
        type: DO_LOGIN_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("verifyLoginOtp", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error,
      };
    });
}

export function resendLoginOtp({ pendingToken }, callback) {
  const url = `${ROOT_URL}/admin/resend-login-otp`;
  return axios
    .post(url, { pendingToken })
    .then((response) => {
      callback(response.data, null);
      return {
        type: RESEND_LOGIN_OTP_SUCCESS,
        payload: null,
      };
    })
    .catch((error) => {
      console.log("resendLoginOtp", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error,
      };
    });
}

export function doLogout() {
  return {
    type: USER_LOGOUT,
    payload: null,
  };
}

export function getOpenRooms(accessToken) {
  const url = `${ROOT_URL}/openRooms`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      console.log("getOpenRooms", response);
      return {
        type: GET_OPEN_ROOMS_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getOpenRooms", error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error.message,
      };
    });
}

export function selectRoomToChat(roomData) {
  return {
    type: SELECT_ROOM_TO_CHAT,
    payload: roomData,
  };
}

export function leaveRoomToChat() {
  return {
    type: LEAVE_ROOM_TO_CHAT,
    payload: null,
  };
}

export function addNewOpenRoom(roomData) {
  return {
    type: ADD_OPEN_ROOM_ON_THE_FLY,
    payload: roomData,
  };
}

export function deleteOpenRoom(roomData) {
  return {
    type: DELETE_OPEN_ROOM_ON_THE_FLY,
    payload: roomData,
  };
}

export function updateOpenRoom(roomData) {
  return {
    type: UPDATE_OPEN_ROOM_ON_THE_FLY,
    payload: roomData,
  };
}

export function createNewAdminUser({ accessToken, data }, callback) {
  const url = `${ROOT_URL}/admin/create`;
  data.department = "call-center";
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      callback(response.status, null);
      return {
        type: CREATE_NEW_ADMIN_USER_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log(error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error,
      };
    });
}

export function getAdminUserList(accessToken) {
  const url = `${ROOT_URL}/admin/userList`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      console.log("getOpenRooms", response);
      return {
        type: GET_ADMIN_USER_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getOpenRooms", error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error.message,
      };
    });
}

// Profile settings only. Changing a password no longer goes through here - see
// requestPasswordChangeOtp / changeAdminPassword below.
export function updateAdminPreferences(
  { accessToken, enableNewChatNotification },
  callback
) {
  const url = `${ROOT_URL}/admin/update-preferences`;
  return axios({
    method: "POST",
    url,
    data: { enableNewChatNotification },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      callback(response.data, null);
      return {
        type: UPDATE_ADMIN_PREFERENCES_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("updateAdminPreferences", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error.message,
      };
    });
}

// Step 1 of a password change: prove the current password, get a code emailed.
export function requestPasswordChangeOtp(
  { accessToken, currentPassword },
  callback
) {
  const url = `${ROOT_URL}/admin/request-password-change-otp`;
  return axios({
    method: "POST",
    url,
    data: { currentPassword },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      callback(response.data, null);
      return {
        type: PASSWORD_CHANGE_OTP_REQUIRED,
        payload: null,
      };
    })
    .catch((error) => {
      console.log("requestPasswordChangeOtp", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error.message,
      };
    });
}

export function resendPasswordChangeOtp(
  { accessToken, pendingToken },
  callback
) {
  const url = `${ROOT_URL}/admin/resend-password-change-otp`;
  return axios({
    method: "POST",
    url,
    data: { pendingToken },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      callback(response.data, null);
      return {
        type: RESEND_LOGIN_OTP_SUCCESS,
        payload: null,
      };
    })
    .catch((error) => {
      console.log("resendPasswordChangeOtp", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error.message,
      };
    });
}

// Step 2: spend the code and set the new password. The server revokes every
// session on success, so the caller must log out afterwards.
export function changeAdminPassword(
  { accessToken, pendingToken, otpCode, newPassword },
  callback
) {
  const url = `${ROOT_URL}/admin/change-password`;
  return axios({
    method: "POST",
    url,
    data: { pendingToken, otpCode, newPassword },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      callback(response.data, null);
      return {
        type: UPDATE_ADMIN_USER_PASSWORD_SUCCESS,
        payload: null,
      };
    })
    .catch((error) => {
      console.log("changeAdminPassword", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error.message,
      };
    });
}

export function getRecordsRooms({ searchType, searchValue, accessToken }) {
  const url = `${ROOT_URL}/rooms/records?searchType=${searchType}&searchValue=${searchValue}`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      console.log("getRecordsRooms", response);
      return {
        type: GET_RECORDS_ROOMS_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getRecordsRooms", error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error.message,
      };
    });
}

export function getStatisticsData({ accessToken, fromDate, toDate }, callback) {
  const url = `${ROOT_URL}/statistics/query?startDate=${fromDate}&endDate=${toDate}`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      console.log("getStatisticsData", response);
      callback(response.status, null);
      return {
        type: GET_STATISTICS_DATA_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getStatisticsData", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error.message,
      };
    });
}

export function addNewNotification(data) {
  return {
    type: ADD_NEW_NOTIFICATION,
    payload: data,
  };
}

export function deleteNotification(data) {
  return {
    type: DELETE_NOTIFICATION,
    payload: data,
  };
}

export function updateNotification(data) {
  return {
    type: UPDATE_NOTIFICATION,
    payload: data,
  };
}


export function verifyAdminInvitation({ token }, callback) {
  const url = `${ROOT_URL}/admin/verify-invitation`;
  return axios
    .post(url, { token })
    .then((response) => {
      callback(response.status, null);
      return {
        type: VERIFY_ADMIN_INVITATION_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("verifyAdminInvitation", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error,
      };
    });
}

export function setupAdminPassword({ token, password }, callback) {
  const url = `${ROOT_URL}/admin/setup-password`;
  return axios
    .post(url, { token, password })
    .then((response) => {
      callback(response.status, null);
      return {
        type: SETUP_ADMIN_PASSWORD_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("setupAdminPassword", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error,
      };
    });
}

export function resendAdminInvitation({ email }, callback) {
  const url = `${ROOT_URL}/admin/resend-invitation`;
  return axios
    .post(url, { email })
    .then((response) => {
      callback(response.status, null);
      return {
        type: RESEND_ADMIN_INVITATION_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("resendAdminInvitation", error);
      callback(null, error);
      return {
        type: DO_API_ERROR_RESPONSE,
        payload: error,
      };
    });
}